export default __webpack_public_path__ + "static/media/CARA_iphone_mockup.b42d7886.png";